<template>
  <div>

    <!-- NON REWARD -->
    <v-card elevation="0" class="ma-0 pa-0" v-if="mode == 'nonreward'">
      <v-card-text>
        <v-row style="border-style: none none dashed none;">
          <v-col cols="2">
            <v-img
              max-height="30"
              max-width="30"
              src="@/assets/receipt_long.png"
            ></v-img>
          </v-col>
          <v-col cols="6">
            <v-row>
              <router-link
                class="text-decoration-none card-no-order"
                :to="`/purchase-details/${item.internalId}/${item.orderNoted}`"
                >{{ item.orderNo }}</router-link
              >
            </v-row>
            <v-row v-if="item.fakturNo != null && item.fakturNo != ''">
              <p class="card-order-date">
                {{ item.fakturNo }}
              </p>
            </v-row>
            <v-row>
              <p class="card-order-date">
                {{ item.orderDate }}
              </p>
            </v-row>
          </v-col>
          <v-col cols="4">
            <div class="descStatus">
              {{
                item.statusCode == "OS_NEW"
                  ? "Di Pesan"
                  : item.statusCode == "OS_PACKING"
                  ? "Di Kemas"
                  : item.statusCode == "OS_UNPAID"
                  ? "Belum Di Bayar"
                  : item.statusCode == "OS_PAID"
                  ? "Lunas"
                  : item.statusCode == "OS_CANCELED"
                  ? "Batal"
                  : ""
              }}
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col v-if="item.orderNoted == 'POIN'">
            <div class="d-flex flex-column">
              <p class="card-order-totalHarga">
                Total Harga Poin
              </p>
              <div class="d-flex flex-row mb-4">
                <v-img
                    max-height="20"
                    max-width="20"
                    src="@/assets/icon-color-coin.svg"
                ></v-img>
                <span class="ml-1" style="color: #FFA800;">{{ item.pointChange}} Poin</span>
              </div>
              <p class="card-order-produkTotal">
                {{ item.updateFlag == $constant.TRX_QUANTITY_TERUPDATE 
                  || item.updateFlag == $constant.TRX_BELUM_TERSEDIA ? item.quantityUpdate : item.countItem }} Produk 
                <span class="card-order-update-quantity">
                  {{ item.updateFlag == $constant.TRX_QUANTITY_TERUPDATE 
                  || item.updateFlag == $constant.TRX_BELUM_TERSEDIA? "(Perubahan Jumlah Produk)" : ""}}
                </span>
              </p>
            </div>
          </v-col>
          <v-col v-else>
            <p class="card-order-totalHarga">
              Total Harga
            </p>
            <p class="card-order-harga">
              Rp. {{ humanFormat(item.totalToBePaidAmt) }}
            </p>
            <p class="card-order-produkTotal">
            {{ item.updateFlag == $constant.TRX_QUANTITY_TERUPDATE 
              || item.updateFlag == $constant.TRX_BELUM_TERSEDIA ? item.quantityUpdate : item.countItem }} Produk 
            <span class="card-order-update-quantity">
              {{ item.updateFlag == $constant.TRX_QUANTITY_TERUPDATE 
              || item.updateFlag == $constant.TRX_BELUM_TERSEDIA? "(Perubahan Jumlah Produk)" : ""}}
            </span>
            </p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card elevation="0" class="ma-0 pa-0" v-else>
      <v-card-text>
        <v-row style="border-style: none none dashed none;">
          <v-col cols="2">
            <v-img
              max-height="30"
              max-width="30"
              src="@/assets/receipt_long.png"
            ></v-img>
          </v-col>
          <v-col cols="6">
            <v-row>
              <router-link v-if="this.tab == 'tabReward'"
                class="text-decoration-none card-no-order"
                :to="`/purchase-details-reward/${item.internalId}`"
                >{{ item.rewardNo }}</router-link
              >
              <router-link v-else
                class="text-decoration-none card-no-order"
                :to="`/purchase-details/${item.internalId}/POIN`"
                >{{ item.rewardNo }}</router-link
              >
            </v-row>
            <v-row>
              <p class="card-order-date">
                {{ item.rewardDate }}
              </p>
            </v-row>
          </v-col>
          <v-col cols="4">
            <div class="descStatus">
              {{
                item.status == 'CANCELED_ADMIN' ? 'Cancel by Admin' : item.status == 'CANCELED_USER' ? 'Cancel by User' 
                : item.rewardNoted
              }}
            </div>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="8">
            <div class="d-flex flex-column">
              <p class="card-order-totalHarga">
                Total Harga Poin
              </p>
              <div class="d-flex flex-row mb-4">
                <v-img
                    max-height="20"
                    max-width="20"
                    src="@/assets/icon-color-coin.svg"
                ></v-img>
                <span class="ml-1" style="color: #FFA800;">{{ item.points}} Poin</span>
              </div>
              <p class="card-order-produkTotal">
                {{ item.quantity }} Produk 
              </p>
            </div>
          </v-col>
          <v-col cols="4" v-if="item.status == 'CLAIM'">
            <v-btn color="green" text @click="pesan(item)">Pesan</v-btn>
            <v-btn color="red" text @click="tolak(item)">Tolak</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="item.rewardNoted == $constant.TRX_QUANTITY_TERUPDATE 
              || item.rewardNoted == $constant.TRX_BELUM_TERSEDIA">
          <v-col>
            <span class="card-order-update-quantity">
              (Perubahan Jumlah Produk)
            </span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['item','mode','tab'],
  methods: {
    pesan(item){
      this.$emit('pesan-item', item)
    },
    tolak(item){
      this.$emit('tolak-item', item)
    }
  }
}
</script>

<style src="./TransactionCard.scss" lang="scss" />